<template>
	<div>
    <div class="filter columns is-variable is-7">
      <div class="column is-one-fifth">
        <div class="select is-fullwidth">
          <select v-model="typeFilter" class="line-input is-primary has-text-weight-bold">
              <option value="">{{ t('all_types') }}</option>
              <option value="part_time">{{ lang === 'en' ? 'Part Time' : 'دوام جزئي'}}</option>
              <option value="full_time">{{ lang === 'en' ? 'Full Time' : 'دوام كلي'}}</option>
          </select>
          <span class="line-control is-primary"></span>
        </div>
      </div>
      <div class="column is-one-fifth is-offset-two-fifths">
        <div class="select is-fullwidth">
          <select v-model="cityFilter" class="line-input is-primary has-text-weight-bold">
              <option value="">{{ t('all_location') }}</option>
              <option v-for="city in cities" :value="city.id">{{city.name}}</option>
          </select>
          <span class="line-control is-primary"></span>
        </div>
      </div>
<!--      <div class="column is-one-fifth">
        <div class="select is-fullwidth">
          <select class="line-input is-primary has-text-weight-bold">
              <option>ترتيب حسب </option>
              <option>ترتيب</option>
              <option>ترتيب</option>
              <option>ترتيب</option>
              <option>ترتيب</option>
          </select>
          <span class="line-control is-primary"></span>
        </div>
      </div>-->
    </div>
		<div v-infinite-scroll="loadNextPage" infinite-scroll-disabled="busy" infinite-scroll-distance="6">
			<div class="mt-6 columns is-multiline is-centered" v-lazy-container="{ selector: 'img' }">
                <div class="column hvr-grow wow fadeInUp" :class="width"  v-for="(job , index) in jobs" :key="`job${index}`">
					<div class="card card-job">
                        <div class="card-content">
                        <div class="content has-text-weight-bold">
                            <p class="mb-0 truncate has-text-primary">
                                {{  job.title }}
                            </p>
                            <p class="mb-0 truncate has-text-primary">
                                {{  job.type }}
                            </p>
                            <p class="mb-0 truncate has-text-primary">
                                {{  job.city }}
                            </p>
                            <a :href="job.route" class="has-text-secondary is-block has-text-left">للمزيد </a>
                        </div>
                        </div>
					</div>
				</div>
			</div>
			<div class="mt-6 has-text-centered content-loader-container" v-show="loadMore">
				<img src="/front/img/illustrations/content_loader.svg" class="content-loader"  alt="">
			</div>
		</div>
	</div>
</template>


<script>
import axios from 'axios';
import infiniteScroll from 'vue-infinite-scroll';
export default {
	name: "Blog",
	directives: {
		infiniteScroll
	},
	props: {
		lang:{
			type: String,
			required: true
		},
        cities:{
            type: Array,
            required: true
        },
		url: String,
		width:{
			type:String,
			default: 'is-4'
		},
		withFilter:{
			type:Boolean,
			default: true
		}
	},
	computed: {
		busy() {
			return this.fetching
		}
	},
	data(){
		return {
			currentPage: 0,
			fetching: true,
			loadMore : true,
			nextUrl : String,
			jobs: [],
            typeFilter:'',
            cityFilter:''
		};
	},
	created() {
		this.nextUrl = this.url;
		this.jobs = [];
		this.loadNextPage();
	},
	mounted() {
		this.$translate.setLang(this.lang);
	},
	methods: {
		loadNextPage() {
			this.currentPage++;
			this.fetching = true;
			if(this.nextUrl != null){
				axios.get(this.nextUrl)
				.then(({ data }) => {
					this.jobs.push(...data.data);
					if(data.links.next != null) {
						this.nextUrl = data.links.next;
					} else {
						this.nextUrl = data.links.next;
					}
					this.fetching = false;
				});
			}
			else{
				this.loadMore = false;
			}
		},
	},
    watch: {
        typeFilter: function (val) {
            if (val !== '') {
                this.jobs = [];
                axios.get(this.url, {
                        params : {'type' : this.typeFilter, 'city' : this.cityFilter}
                    }
                ).then(({data}) => {
                    this.jobs = data.data;
                    if(data.links.next != null) {
                        this.loadMore = true;
                        this.nextUrl = data.links.next;
                    } else {
                        this.nextUrl = data.links.next;
                        this.loadMore = false;
                    }
                    this.currentPage = 0;
                    this.fetching = false;
                });
            } else {
                this.jobs = [];
                axios.get(this.url, {
                        params : {'city' : this.cityFilter}
                    }
                ).then(({data}) => {
                    this.jobs = data.data;
                    if(data.links.next != null) {
                        this.loadMore = true;
                        this.nextUrl = data.links.next;
                    } else {
                        this.nextUrl = data.links.next;
                        this.loadMore = false;
                    }
                    this.currentPage = 0;
                    this.fetching = false;
                });
            }
        },
        cityFilter: function (val) {
            if (val !== '') {
                this.jobs = [];
                axios.get(this.url, {
                        params : {'type' : this.typeFilter, 'city' : this.cityFilter}
                    }
                ).then(({data}) => {
                    this.jobs = data.data;
                    if(data.links.next != null) {
                        this.loadMore = true;
                        this.nextUrl = data.links.next;
                    } else {
                        this.nextUrl = data.links.next;
                        this.loadMore = false;
                    }
                    this.currentPage = 0;
                    this.fetching = false;
                });
            } else {
                this.jobs = [];
                axios.get(this.url, {
                        params : {'type' : this.typeFilter}
                    }
                ).then(({data}) => {
                    this.jobs = data.data;
                    if(data.links.next != null) {
                        this.loadMore = true;
                        this.nextUrl = data.links.next;
                    } else {
                        this.nextUrl = data.links.next;
                        this.loadMore = false;
                    }
                    this.currentPage = 0;
                    this.fetching = false;
                });
            }
        }
    }

}
</script>

<style scoped lang="scss">


</style>
